import styles from './PageContainer.module.css';

type Props = {
  children: React.ReactNode;
};

export const PageContainer = ({children}: Props) => (
  <div className={styles.root}>{children}</div>
);
